"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureAndLogIfSlow = exports.measureExecutionTime = void 0;
const constants_1 = require("../types/constants");
/**
 * Measures the execution time of a synchronous or asynchronous callback function and returns the result.
 * It also logs the execution time to the console.
 *
 * @template T - The type of the value returned by the callback function.
 * @param name - The optional name of the callback function to be used in the log message.
 * @param cb - The callback function to measure the execution time. It can be synchronous or asynchronous.
 * @returns A promise that resolves to the result returned by the callback function.
 * @throws Any error that occurs during the execution of the callback function.
 */
function measureExecutionTime(name, cb) {
    return __awaiter(this, void 0, void 0, function* () {
        const start = Date.now(); // Record the start time
        try {
            const result = yield Promise.resolve(cb()); // Execute the callback and wait if it's asynchronous
            const end = Date.now(); // Record the end time
            const executionTime = end - start; // Calculate execution time
            const callbackName = name || cb.name || 'Anonymous Callback'; // Determine the name to use in the log
            console.info(`measureExecutionTime - ${callbackName} took ${executionTime}ms`); // Log the execution time
            return result; // Return the result of the callback function
        }
        catch (error) {
            console.error(`measureExecutionTime - Error in ${name || 'Anonymous Callback'}: ${error.message}`); // Log the error if any occurs
            throw error; // Rethrow the error to propagate it
        }
    });
}
exports.measureExecutionTime = measureExecutionTime;
/**
 * Measures the execution time of a synchronous or asynchronous callback function and returns the result.
 * If the execution time exceeds a specified threshold, it logs a warning message to the console.
 *
 * @template T - The type of the value returned by the callback function.
 * @param name - The optional name of the callback function to be used in the log message.
 * @param cb - The callback function to measure the execution time. It can be synchronous or asynchronous.
 * @param tooLongQueryTime - The threshold in milliseconds for logging long executions. Defaults to `DEFAULT_TOO_LONG_QUERY_TIME`.
 * @returns A promise that resolves to the result returned by the callback function.
 * @throws Any error that occurs during the execution of the callback function.
 */
function measureAndLogIfSlow(name, cb, tooLongQueryTime = constants_1.TIME_THRESHOLD_MS) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const start = Date.now(); // Record the start time
        try {
            const result = yield Promise.resolve(cb()); // Execute the callback and wait if it's asynchronous
            const end = Date.now(); // Record the end time
            const executionTime = end - start; // Calculate execution time
            const callbackName = (_a = name !== null && name !== void 0 ? name : cb.name) !== null && _a !== void 0 ? _a : 'Anonymous Callback'; // Use 'Anonymous Callback' if no name is provided
            if (executionTime >= tooLongQueryTime) {
                console.warn(`measureAndLogIfSlow - ${callbackName} took ${executionTime}ms (exceeded ${tooLongQueryTime}ms)`); // Log a warning if execution time exceeds the threshold
            }
            return result; // Return the result of the callback function
        }
        catch (error) {
            console.error(`measureAndLogIfSlow - Error in ${name}: ${error.message}`); // Log the error if any occurs
            throw error; // Rethrow the error to propagate it
        }
    });
}
exports.measureAndLogIfSlow = measureAndLogIfSlow;
//# sourceMappingURL=executionTimeLogger.js.map